import { Icon } from '@iconify/vue'
import { h } from 'vue'

export const SearchIcon = (height: number = 16) => h(Icon, { icon: 'material-symbols:search-rounded', height: height })
